<div class="toast-container" [ngClass]="type">
    <div class="toast-content">
    {{ message }}
    </div>
    <button (click)="closed.emit()">X</button>
</div>